import React, { useEffect } from "react";
import './css/AdminNavbar.css'
import { useSelector, useDispatch } from "react-redux";
import {
  openNav,
  closeNav,
  toggleParent,
  setActiveChild,
  clearMessage,
} from "../feature/navbarSlice.js";
import { Link } from "react-router-dom";

export default function AdminNavbar() {
  const dispatch = useDispatch();
  const { navOpen, openParent, activeChild, message } = useSelector(
    (state) => state.navbar
  );
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => dispatch(clearMessage()), 5000);
      return () => clearTimeout(timer);
    }
  }, [message, dispatch]);

  const navItems = [
    {
      id: "AdminPanel",
      title: "Admin Panel",
      children: [
        { label: "About Us Mission And vision", link: "/admin/about-us-mission-and-vision" },
        { label: "Core Initiative List", link: "/admin/core_initiative_list" },
        { label: "Core Service List", link: "/admin/core-services" },
        { label: "Events", link: "/admin/events" },
        { label: "Home banner", link: "/admin/home-page-banners" },
        { label: "Home Page Galleries", link: "/admin/home-page-galleries" },
        { label: "Initiatives", link: "/admin/initiatives" },
        { label: "Team Members", link: "/admin/team-members" },
        { label: "Word That Inspire", link: "/admin/words-that-inspire" },
        { label: "Images", link: "/admin/media-file" },
        { label: "Faq List", link: "/admin/faq-list" },
         { label: "Volunteer List", link: "/admin/volunteer-list" },
          { label: "Contact-us List", link: "/admin/contact-us" },
           { label: "NewsLetter List", link: "/admin/newsletter" },
      ],
    }

  ];


  return (
    <div>

      {message && (
        <div className={`top-message ${message.type}`}>
          {message.text}
        </div>
      )}

      <button
        className="admin-nav-toggle"
        onClick={() => dispatch(openNav())}
        aria-label="Open navigation"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      <div className={`admin-side-panel ${navOpen ? "open" : ""}`}>
        <button
          className="admin-nav-close"
          onClick={() => dispatch(closeNav())}
          aria-label="Close navigation"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <h2 className="admin-nav-title">Navigation</h2>
        <ul className="admin-nav-links">
          {navItems.map((item) => (
            <li key={item.id}>
              <div
                className="admin-parent-link"
                onClick={() => dispatch(toggleParent(item.id))}
              >
                <span>{item.title}</span>
                {item.children && (
                  <svg
                    className={`admin-arrow ${openParent === item.id ? "rotated" : ""}`}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                )}
              </div>

           
              {item.children && openParent === item.id && (
                <ul className="admin-sub-links">
                  {item.children.map((c) => (
                    <Link
                      key={c.label}
                      to={c.link}
                      onClick={() => dispatch(setActiveChild(c.label))}
                      className={activeChild === c.label ? "active" : ""}
                      style={{ display: "flex", flexDirection: "column", color: "black" }}
                    >
                      {c.label}
                    </Link>
                  ))}
                </ul>
              )}

            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
